import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Spinner,
} from "reactstrap";
import { updateRestaurantImage } from "store/actions/settingAction";
import Dropzone from "react-dropzone";

const EditRestaurantImageModal = ({
  editModal,
  editToggle,
  editData,
  index,
}) => {
  const dispatch = useDispatch();
  const { imageLoading } = useSelector((state) => state.setting);
  const { user } = useSelector((state) => state.auth);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(editData);

  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (!image) {
      toast.warn("Please select an image");
      return;
    }

    dispatch(
      updateRestaurantImage(user?.restaurantID, index, image, editData, () => {
        editToggle();
      })
    );
  };

  useEffect(() => {
    if (editModal) {
      setImage(null);
      setImagePreview(editData);
    }
  }, [editModal, editData]);

  return (
    <Modal isOpen={editModal} toggle={editToggle}>
      <ModalHeader toggle={editToggle}>Edit Restaurant Image</ModalHeader>
      <ModalBody className="pt-0">
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Restaurant Image</Label>
            <Dropzone onDrop={handleDrop} multiple={false} accept="image/*">
              {({ getRootProps, getInputProps, isDragActive }) => (
                <section
                  className="dropzone"
                  style={{
                    border: "2px dashed #6c757d",
                    backgroundColor: isDragActive ? "#f8f9fa" : "#fff",
                    height: "140px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "background-color 0.3s ease",
                    marginBottom: "1.5rem",
                  }}
                >
                  <div className="text-center p-2" {...getRootProps()}>
                    <input {...getInputProps()} />
                    <i className="fas fa-upload fa-2x mb-2 text-primary opacity-5"></i>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "0.9rem",
                        color: "#6c757d",
                      }}
                    >
                      {isDragActive
                        ? "Drop the image here..."
                        : "Drag & drop or click to select image"}
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </FormGroup>

          <div className="d-flex justify-content-center mb-4">
            <img
              src={imagePreview}
              alt="Restaurant"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                border: "1px solid #dee2e6",
              }}
            />
          </div>

          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              type="submit"
              disabled={imageLoading || !image}
            >
              {imageLoading ? <Spinner size="sm" /> : "Update"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default EditRestaurantImageModal;
